
import { useState, useCallback } from 'react';
import { StatCardData } from '../types';
import { useToast } from '@/hooks/use-toast';
import { saveCardsToStorage } from '../utils/storage';

export const useCardVisibility = (
  cards: StatCardData[],
  setCards: React.Dispatch<React.SetStateAction<StatCardData[]>>
) => {
  const { toast } = useToast();
  
  const toggleCardVisibility = useCallback((cardId: string, visible?: boolean) => {
    setCards(prevCards => {
      const updatedCards = prevCards.map(card => {
        if (card.id === cardId) {
          // If visible is specified, use that value, otherwise toggle the current value
          const newVisibility = visible !== undefined ? visible : !(card.visible === false);
          
          // Show toast notification
          setTimeout(() => {
            toast({
              title: newVisibility ? "Card Visible" : "Card Hidden",
              description: `"${card.title}" is now ${newVisibility ? "visible" : "hidden"}`
            });
          }, 0);
          
          return { ...card, visible: newVisibility };
        }
        return card;
      });
      
      // Save to localStorage
      saveCardsToStorage(updatedCards);
      
      return updatedCards;
    });
  }, [setCards, toast]);
  
  // Get list of hidden cards
  const hiddenCards = cards.filter(card => card.visible === false);
  
  return { toggleCardVisibility, hiddenCards };
};
